export type DecorationThemePreset = {
  code: string
  name: string
  primaryColor: string
  accentColor: string
  backgroundColor: string
  backgroundImage?: string
  cardColor: string
  textColor: string
  mutedTextColor: string
  buttonTextColor: string
  borderColor: string
  headerMode?: 'HERO' | 'COMPACT' | 'HIDDEN'
}

export const layoutModeOptions: Array<{ value: string; label: string }> = [
  { value: 'FREE', label: '自由专题页' },
  { value: 'TABBAR_SHELL', label: '动态 TabBar 壳' },
  { value: 'PRODUCT_DETAIL', label: '商品详情页' },
  { value: 'SHOP_HOME', label: '店铺首页' },
  { value: 'TOPIC', label: '营销专题页' },
]

export const headerModeOptions: Array<{ value: string; label: string }> = [
  { value: 'HERO', label: '大标题头部' },
  { value: 'COMPACT', label: '紧凑应用栏' },
  { value: 'HIDDEN', label: '隐藏头部' },
]

export const themePresets: readonly DecorationThemePreset[] = [
  {
    code: 'brand',
    name: '靖紫',
    primaryColor: '#5A46E0',
    accentColor: '#4B39C7',
    backgroundColor: '#F3F5F7',
    cardColor: '#FFFFFF',
    textColor: '#171A1F',
    mutedTextColor: '#67717F',
    buttonTextColor: '#FFFFFF',
    borderColor: '#E1E5EA',
    headerMode: 'COMPACT',
  },
  {
    code: 'mystic',
    name: '星紫',
    primaryColor: '#9B4DFF',
    accentColor: '#48A8FF',
    backgroundColor: '#160A29',
    cardColor: '#2A1747',
    textColor: '#FFFFFF',
    mutedTextColor: '#AD9CC8',
    buttonTextColor: '#FFFFFF',
    borderColor: '#4B2E72',
    headerMode: 'COMPACT',
  },
  {
    code: 'jade',
    name: '青玉',
    primaryColor: '#087F8C',
    accentColor: '#12A594',
    backgroundColor: '#F2F8F7',
    cardColor: '#FFFFFF',
    textColor: '#17313A',
    mutedTextColor: '#667B80',
    buttonTextColor: '#FFFFFF',
    borderColor: '#D6E7E4',
  },
  {
    code: 'amber',
    name: '琥珀',
    primaryColor: '#D49A00',
    accentColor: '#F3B61F',
    backgroundColor: '#FFF9EA',
    cardColor: '#FFFFFF',
    textColor: '#332B19',
    mutedTextColor: '#786E58',
    buttonTextColor: '#FFFFFF',
    borderColor: '#EFE1B8',
  },
  {
    code: 'coral',
    name: '珊瑚',
    primaryColor: '#D95852',
    accentColor: '#F08A77',
    backgroundColor: '#FFF5F3',
    cardColor: '#FFFFFF',
    textColor: '#3C2524',
    mutedTextColor: '#806866',
    buttonTextColor: '#FFFFFF',
    borderColor: '#F0D8D4',
  },
  {
    code: 'indigo',
    name: '靛蓝',
    primaryColor: '#315E9B',
    accentColor: '#4C82C3',
    backgroundColor: '#F3F6FA',
    cardColor: '#FFFFFF',
    textColor: '#1C2B3D',
    mutedTextColor: '#687789',
    buttonTextColor: '#FFFFFF',
    borderColor: '#DCE3EB',
  },
]
